<template>
  <div>文明志愿者</div>
</template>

<script>
export default {

}
</script>

<style>

</style>